module.exports = __webpack_public_path__ + "static/eindruecke12-ede67bcc90f8c73c5046fd908ef1677c.jpg";